import { useCallback, useEffect, useMemo, useRef } from 'react';
import { useAuth } from '../../App';
export const purchaseBase = import.meta.env.VITE_API_URL || 'https://api.whenlyapp.com';
export function usePurchaseAccount() {
  const { user, currentShop, currentOrganization, hasPermission } = useAuth();
  const account = useMemo(() => ({ userId: String(user?.id || ''), domain: currentShop?.domain || '', organizationId: currentOrganization?.id || '' }), [user?.id, currentShop?.domain, currentOrganization?.id]);
  return { account, canView: !!user?.id && !!account.domain && hasPermission('inventory.view'), canEdit: hasPermission('inventory.manage') };
}
export function usePurchaseCurrent() {
  const mounted = useRef(true); useEffect(() => { mounted.current = true; return () => { mounted.current = false; }; }, []);
  return useCallback(() => mounted.current, []);
}
